<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="section-header">
          <h3>Services</h3>
          <p class="text-muted font-weight-light">
            Profite de tous les services disponibles
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <ServiceCard
        :key="index"
        v-for="(item, index) in items"
        :description="item.description"
        :title="item.title"
        :link_type="item.link_type"
        :extern_link="item.extern_link"
        :url="item.url"
        :modal_id="item.action"
      />
    </div>
  </div>
</template>

<script>
import ServiceCard from "@/components/utils/ServiceCard";
import { subscriber } from "@/services/";
export default {
  components: { ServiceCard },
  name: "ServicesList",
  data: function () {
    return {
      items: this.utils_get_config_item("services_list"),
    };
  },
  mounted: async function () {
    await subscriber.get_bundle_list();
  },
  methods: {},
};
</script>
<style scoped lang="css">
</style>
